import axios from "../axiosInstance";
import fileDownload from "js-file-download";

/**
 * Retrieves the list of courses followd by the current user
 *
 * @returns {Promise<Array<Course>>} - the list of courses followed by the current user
 */
export const retrieveFollowedCourses = async () => {
  return await axios.get("/students/courses/").then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};

/**
 * Enrolls into a course
 *
 * @param {string} uuid - the uuid of the course
 */
export const attempCourseEnrollment = async (uuid) => {
  return await axios.post(`/students/courses/${uuid}/`).then((res) => {
    if (res.status !== 201) {
      throw new Error(res.data.code);
    }
  });
};

/**
 * Unenrolls from a course
 *
 * @param {string} uuid - the uuid of the course
 */
export const attempCourseUnenrollment = async (uuid) => {
  return await axios.delete(`/students/courses/${uuid}/`).then((res) => {
    if (res.status !== 200) {
      throw new Error(res.data.code);
    }
  });
};

/**
 * Retrieves information about a course
 *
 * @param {string} uuid - the uuid of the course
 * @returns {Promise<Course>} - the course info
 */
export const retrieveCourseInfo = async (uuid) => {
  return await axios.get(`/students/courses/${uuid}/`).then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};

/**
 * Retrives information about a lecture
 *
 * @param {string} uuid - the uuid of the lecture
 * @returns {Promise<Lecture>} - the lecture information
 */
export const retrieveLectureInfo = async (uuid) => {
  return await axios.get(`/students/lectures/${uuid}/`).then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};

/**
 * Download slides of the lecture
 *
 * @param {string} uuid - the uuid of the lecture
 * @returns
 */
export const attempDownloadSlides = async (uuid) => {
  return await axios
    .get(`/students/lectures/${uuid}/slides?attachment=true`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    })
    .then((res) => {
      if (res.status === 200) {
        const filename = res.headers["content-disposition"].split("=")[1];
        fileDownload(res.data, filename);

        return res.data.data;
      } else {
        throw new Error(res.data.code);
      }
    });
};
